import { render } from "./MediaBrowser.vue?vue&type=template&id=37a8780b"
import script from "./MediaBrowser.vue?vue&type=script&lang=js"
export * from "./MediaBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__